import type {
  PromotedProductDiscountRuleAmount,
  PromotedProductDiscountRuleAmountFragment,
  PromotedProductDiscountRulePercentage,
  PromotedProductDiscountRulePercentageFragment,
  PromotedProductTriggerRuleAmount,
  PromotedProductTriggerRuleAmountFragment,
  PromotedProductTriggerRuleQuantity,
  PromotedProductTriggerRuleQuantityFragment,
} from '@shared/shop-api/product/attributes/types'

export const isPromotedProductDiscountRuleAmount = (
  rule: unknown
): rule is PromotedProductDiscountRuleAmount => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'amount' in rule && 'currencyCode' in rule
  const hasAttributesOfType =
    hasAttributes &&
    typeof rule.amount === 'number' &&
    typeof rule.currencyCode === 'string'
  const hasValues =
    hasAttributesOfType && rule.amount !== '' && rule.currencyCode !== ''

  return hasValues
}

export const isPromotedProductDiscountRulePercentage = (
  rule: unknown
): rule is PromotedProductDiscountRulePercentage => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'percentage' in rule
  const hasAttributesOfType =
    hasAttributes && typeof rule.percentage === 'number'

  return hasAttributesOfType
}

export const isPromotedProductTriggerRuleQuantity = (
  rule: unknown
): rule is PromotedProductTriggerRuleQuantity => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'quantity' in rule
  const hasAttributesOfType = hasAttributes && typeof rule.quantity === 'number'
  const hasValues = hasAttributesOfType && (rule.quantity as number) > 0

  return hasValues
}

export const isPromotedProductTriggerRuleAmount = (
  rule: unknown
): rule is PromotedProductTriggerRuleAmount => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'amount' in rule
  const hasAttributesOfType = hasAttributes && typeof rule.amount === 'number'
  const hasValues = hasAttributesOfType && (rule.amount as number) > 0

  return hasValues
}

export const isPromotedProductDiscountRuleAmountFragment = (
  rule: unknown
): rule is PromotedProductDiscountRuleAmountFragment => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'amount' in rule && 'currencyCode' in rule
  const hasAttributesOfType =
    hasAttributes &&
    typeof rule.amount === 'string' &&
    typeof rule.currencyCode === 'string'
  const hasValues =
    hasAttributesOfType && rule.amount !== '' && rule.currencyCode !== ''

  return hasValues
}

export const isPromotedProductDiscountRulePercentageFragment = (
  rule: unknown
): rule is PromotedProductDiscountRulePercentageFragment => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'percentage' in rule
  const hasAttributesOfType =
    hasAttributes && typeof rule.percentage === 'string'
  const hasValues = hasAttributesOfType && rule.percentage !== ''

  return hasValues
}

export const isPromotedProductTriggerRuleQuantityFragment = (
  rule: unknown
): rule is PromotedProductTriggerRuleQuantityFragment => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'quantity' in rule
  const hasAttributesOfType = hasAttributes && typeof rule.quantity === 'string'
  const hasValues = hasAttributesOfType && rule.quantity !== ''

  return hasValues
}

export const isPromotedProductTriggerRuleAmountFragment = (
  rule: unknown
): rule is PromotedProductTriggerRuleAmountFragment => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'amount' in rule
  const hasAttributesOfType = hasAttributes && typeof rule.amount === 'string'
  const hasValues = hasAttributesOfType && rule.amount !== ''

  return hasValues
}
